import axios from 'axios';
import router from '@/router/router';

const methods = {
  getImgSrc: function (src) {
    try {
      const result = require(`@/assets/images/${src}`);
      return result;
    }
    catch (e) {
      return;
    }
  },
  setResult: function (data) {
    const newObj = { ...data };
    newObj.result = newObj.realtime;
    return newObj;
  },
  filterDate: function (start, end, date) {
    let cond1, cond2;
    const [start_year, start_month, start_date] = start.split("-");
    const [end_year, end_month, end_date] = end.split("-");
    const [year_, month_, date_] = date.split(" ")[0].split("-");

    if (start_year < year_) cond1 = true
    else if (start_year > year_) cond1 = false
    else if (start_year == year_) {
      if (start_month < month_) cond1 = true
      else if (start_month > month_) cond1 = false
      else if (start_month == month_) {
        if (start_date <= date_) cond1 = true
        else if (start_date > date_) cond1 = false
      }
    }

    if (end_year > year_) cond2 = true
    else if (end_year < year_) cond2 = false
    else if (end_year == year_) {
      if (end_month > month_) cond2 = true
      else if (end_month < month_) cond2 = false
      else if (end_month == month_) {
        if (end_date >= date_) cond2 = true
        else if (end_date < date_) cond2 = false
      }
    }

    return (cond1 && cond2)
  },

  reduceImgSize: function (base64, callback) {
    const img = new Image();
    img.src = base64;
    const type = base64.split('data:')[1].split(';')[0]

    let reducedBase64 = null;
    return img.onload = (e) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = e.target.width;
      canvas.height = e.target.height;

      ctx.drawImage(e.target, 0, 0);

      reducedBase64 = canvas.toDataURL(type, 0.5);
      callback(reducedBase64);
    }
  },

  getImgOriginSize: function (src, callback) {
    const img = new Image();
    img.src = src;
    img.onload = function () {
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      callback({ width, height })
    }
  },

  NumToKm: function (num) {
    if (num == null) return num;
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  },

  isNull: function (value, def = '') {
    return (value == null || value == '') ? def : value
  },
}

const ParseResult = (result) => {
  if (result.code === -1) {
    return [false, 'disconnect', result.err]
  }
  else if (result.code === 0) {
    return [false, 'server_error']
  }
  else if (result.data && result.data.sessionExpired === true) {
    return [false, 'session_expired']
  }
  else {
    return [true, result.data]
  }
}

const repeat = {}
const repeatRequest = (result, method, url, params) => {
  const [success, data, err] = result
  if (success) {
    delete repeat[url]
    return data
  }
  else if (data === 'disconnect') {
    repeat[url] = repeat[url] === undefined ? 0 : repeat[url] + 1

    if (repeat[url] > 3) {
      delete repeat[url]
      console.log('server error! ', err)
      router.push({ name: 'ServerError' })
      window.alert('Connection to the server has been lost.')
      return false
    }
    else {
      switch (method) {
        case 'get':
          setTimeout(() => API.get(url, params), 1000)
          break;
        case 'post':
          setTimeout(() => API.post(url, ...params), 1000)
          break;
        case 'put':
          setTimeout(() => API.put(url, ...params), 1000)
          break;
        case 'delete':
          setTimeout(() => API.delete(url, params), 1000)
          break;
        default:
          break;
      }
    }
  }
  else if (data === 'server_error') {
    delete repeat[url]
    window.alert('Server connection error')
    return false
  }
  else if (data === 'session_expired') {
    delete repeat[url]
    if (router.currentRoute.name !== 'login') {
      window.alert('Session has expired.')
      router.push({ name: 'login' })
    }
    return false
  }
}

const API = {
  get: async (url = '', params = {}) => {
    const result = await axios.get(url, { params: params })
      .then(res => res.data)
      .catch(err => {
        return { code: -1, err: err }
      })

    return repeatRequest(ParseResult(result), 'get', url, params)
  },

  post: async (url = '', ...args) => {
    const result = await axios.post(url, ...args)
      .then(res => res.data)
      .catch(err => {
        console.log(err);
        return { code: -1 }
      })

    return repeatRequest(ParseResult(result), Date.now(), 'post', url, ...args)
  },

  put: async (url = '', ...args) => {
    const result = await axios.put(url, args[0], args[1])
      .then(res => res.data)
      .catch(err => {
        console.log(err);
        return { code: -1 }
      })

    return repeatRequest(ParseResult(result), Date.now(), 'put', url, ...args)
  },

  delete: async (url = '', params) => {
    const result = await axios.delete(url, { data: params })
      .then(res => res.data)
      .catch(err => {
        console.log(err);
        return { code: -1 }
      })

    return repeatRequest(ParseResult(result), Date.now(), 'delete', url, params)
  }
}

// 정규식
const reg = {
  search: /[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣|0-9a-zA-Z|-\s]/g,
  all: /[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣|0-9a-zA-Z|-\s._()+/]/g,
  email: /[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣|0-9a-zA-Z|\-@.]/g,
  string: /[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣|0-9a-zA-Z|\s]/g,
  number: /[^0-9]/g,
  pwd: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#$%^&*()+|=])[A-Za-z\d~!@#$%^&*()+|=]{8,20}$/
}

// validation
const validate = (value, type) => {
  let result
  if (type === 'cellphone') {
    const reg = /^([0-9]{2,3})-?([0-9]{3,4})-?([0-9]{4})$/
    result = reg.test(value)
    if (result === false) window.alert('Please check the phone number.')
  }
  else if (type === 'email') {
    const reg = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
    result = reg.test(value)
    if (result === false) window.alert('Please check the email.')
  }
  return result
}

export default {
  // install(Vue, options) {
  install(Vue) {
    Vue.prototype.$getImgSrc = methods.getImgSrc;
    Vue.prototype.$setResult = methods.setResult;
    Vue.prototype.$filterDate = methods.filterDate;
    Vue.prototype.$reduceImgSize = methods.reduceImgSize;
    Vue.prototype.$getImgOriginSize = methods.getImgOriginSize;
    Vue.prototype.$convertToKm = methods.NumToKm;
    Vue.prototype.$isNull = methods.isNull;

    Vue.prototype.$API = API;

    Vue.prototype.$reg = reg;
    Vue.prototype.$validate = validate;
  }
}
